import { AccountType } from "@/enums/account-type";
import { SubscriptionBillingMode } from "@/enums/subscription-billing-mode";

export default {
  subscriptionDetails: state => (state.company && state.company.subscription_details) || null,
  subscriptionBillingMode: (state, getters) =>
    getters.subscriptionDetails && getters.subscriptionDetails.billing_mode,
  hasStripeSubscription: (state, getters) =>
    getters.subscriptionBillingMode === SubscriptionBillingMode.STRIPE,
  canSelectSubscriptionPlan: (state, getters) =>
    [SubscriptionBillingMode.TRIAL, SubscriptionBillingMode.NOT_STARTED].includes(
      getters.subscriptionBillingMode
    ),
  hasSelfServiceBilling: (state, getters) =>
    getters.hasStripeSubscription || getters.canSelectSubscriptionPlan,
  canEditSubscriptionBilling: (state, getters) =>
    getters.hasSelfServiceBilling,
  subscriptionSummary: (state, getters) => {
    const details = getters.subscriptionDetails;
    const supportsQuota = [
      SubscriptionBillingMode.TRIAL,
      SubscriptionBillingMode.STRIPE
    ].includes(getters.subscriptionBillingMode);
    return details && !details.is_expired && supportsQuota ? details : null;
  },
  hasSelfServiceSubscription: (state, getters) =>
    Boolean(getters.subscriptionSummary),
  showSubscriptionQuota: (state, getters) =>
    getters.hasSelfServiceSubscription &&
    [AccountType.OWNER, AccountType.ADMIN].includes(
      state.company.company_user.type
    ),
  isWizardCompleted: state => state.isWizardCompleted,
  companyId: state => state.company && state.company.id,
  canAddCompany: state =>
    state.companies.some(
      company =>
        company.company_user.type === AccountType.OWNER &&
        company.is_master &&
        company.can_add_new_companies
    ),
  canCreateNewFacility: state =>
    state.company && state.company.can_create_gmb_locations,
  allFacilitiesAccess: state =>
    state.company &&
    (state.company.company_user.all_facilities_access ||
      state.company.company_user.type === AccountType.OWNER ||
      state.company.company_user.type === AccountType.ADMIN),
  hasStoreLocator: state =>
    state.company && state.company.enabled_store_locator,
  hasReviewBooster: state =>
    state.company && state.company.enabled_review_booster,
  accountType: state => state.company.company_user.type,
  isSubscriptionPlanClient: state =>
    Boolean(state.company && state.company.is_subscription_plan_client),
  isUnpaidSubscription: state =>
    Boolean(
      state.company &&
      !state.company.has_billing_subscription &&
      state.company.is_subscription_plan_client
    ),
  acquisitionCampaign: state => state.company.acquisition_campaign,
  facilitiesCount: state => state.company.facilities_count,
  reviewCategoriesDisplayLimit: state =>
    state.company.review_categories_display_limit
};
